import React from "react"
import { monthLabel } from "./plannerLabels"
import { nextMonth, previousMonth, seasonOfMonth } from "./plannerQuery"

const VIEW_LABELS = [["season", "Season"], ["month", "Month"], ["list", "List"]]
const GROUP_LABELS = [["region", "Region"], ["organizer", "Organizer"]]
const DENSITY_LABELS = [["comfortable", "Comfortable"], ["compact", "Compact"]]

const Segmented = ({ label, options, value, onChange }) => <span role="group" aria-label={label} className="ep-segment">
  {options.map(([key, text]) => <button type="button" key={key} aria-pressed={value === key} className={"ep-chip" + (value === key ? " is-on" : "")}
    onClick={() => onChange(key)}>{text}</button>)}
</span>

// The view's own controls (ticket 15): Season, Month or List; Season grouped by region or organizer; the Month's month, Today and
// density; and the Holidays. A month outside the season's view takes the season it belongs to.
export default function PlannerViewBar({ query, today, onChange, onHolidays }) {
  const toMonth = month => onChange({ month, season: seasonOfMonth(month, query.season) })
  return <div className="ep-view-bar">
    <Segmented label="View" options={VIEW_LABELS} value={query.view} onChange={view => onChange({ view })} />
    {query.view === "season" && <>
      <span className="ep-label">Group by</span>
      <Segmented label="Group by" options={GROUP_LABELS} value={query.group} onChange={group => onChange({ group })} />
    </>}
    {query.view === "month" && <>
      <span className="ep-season">
        <button type="button" className="ep-icon-button" aria-label="Previous month" onClick={() => toMonth(previousMonth(query.month))}>
          <i className="bx bx-chevron-left" aria-hidden="true" /></button>
        <b aria-live="polite">{monthLabel(`${query.month}-01`)}</b>
        <button type="button" className="ep-icon-button" aria-label="Next month" onClick={() => toMonth(nextMonth(query.month))}>
          <i className="bx bx-chevron-right" aria-hidden="true" /></button>
      </span>
      <button type="button" className="btn btn-light btn-sm" onClick={() => toMonth(today.slice(0, 7))}>Today</button>
      <Segmented label="Density" options={DENSITY_LABELS} value={query.density} onChange={density => onChange({ density })} />
    </>}
    <span className="ep-spacer" />
    <button type="button" className="btn btn-light btn-sm" onClick={onHolidays}><i className="bx bx-flag" aria-hidden="true" /> Holidays</button>
  </div>
}
